import { useAuthService } from '@/api/authService';
import { useUserStore } from '@/stores/userStore';
import { AppSwitcher } from '@teamworksdev/vuetify';
import { computed } from 'vue';
import { handleError } from '@/utils/errorHandling';

export function useAppSwitcher() {
	const authService = useAuthService();
	const userStore = useUserStore();

	async function getTokenFn() {
		try {
			const { token } = await authService.getOutgoingAxleToken();
			return token;
		} catch (e) {
			handleError(e);
			return '';
		}
	}

	const appSwitcher = computed(() => {
		if (!userStore.userAxleProfile) return null;
		return new AppSwitcher(
			AppSwitcher.slugs.INFLCR,
			getTokenFn,
			userStore.userAxleProfile.appTargetUrls,
		);
	});

	return {
		appSwitcher,
	};
}
